(() => {
  'use strict';
  const bars = new Set();
  const visible = new WeakSet();
  const update = bar => bar.classList.toggle('is-breathing', visible.has(bar) && !document.hidden);
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) visible.add(target); else visible.delete(target);
      update(target);
    });
  }, { threshold: 0.15 }) : null;
  const init = root => root.querySelectorAll('[data-studio-pulse]').forEach(bar => {
    if (bars.has(bar)) return;
    bars.add(bar);
    if (observer) observer.observe(bar);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('visibilitychange', () => bars.forEach(update));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    bars.forEach(bar => {
      if (!event.target.contains(bar)) return;
      observer?.unobserve(bar); visible.delete(bar); bars.delete(bar);
    });
  });
})();
